import React, { useState, useEffect } from "react";
import BoxContainer from "components/BoxContainer";
import Text from "components/Text";
import Button from "../Button";
import EnquiryForm from "components/EnquiryForm";
import iconResolver from "utils/icon-resolver";
import amazonSvg from "assets/clients-white/amazon-white.svg";
import googleSvg from "assets/clients-white/google-white.svg";
import microsoftSvg from "assets/clients-white/microsoft-white.svg";
import wixSvg from "assets/clients-white/wix-white.svg";
import bloombergSvg from "assets/clients-white/bloomberg-white.svg";

const HeroBanner = ({ title, description, buttonDetails, seal, enquiry_form }) => {
  const useExperiment = (experimentId) => {
    const [variant, setVariant] = useState();
    useEffect(() => {
      (async () => {
        // if (window.dataLayer) {
        //   await window.dataLayer.push({ event: "optimize.activate" });
        // }
        const intervalId = setInterval(() => {
          if (window.google_optimize !== undefined) {
            // Set the variant to the state.
            setVariant(window.google_optimize.get(experimentId));
            clearInterval(intervalId);
          }
        }, 100);
      })();
    });
    return variant;
  };
  const variant = useExperiment("yWZT-4xlS9-M9AZuPD95Xg");

  return (
    <div className="bg-gradient1 lg:bg-desktop bg-cover bg-no-repeat bg-center py-10 px-0">
      <BoxContainer background="transparent" className="px-0 md:px-0">
        <div className="flex flex-col lg:flex-row gap-6 xl:gap-0 w-full px-3 sm:px-0 sm:w-11/12 xl:w-10/12 2xl:w-9/12 max-w-7xl mx-auto justify-between items-start 2xl:max-w-6xl">
          <div className={`flex flex-col text-midBlue max-w-xl xl:max-w-[600px]`}>
            <Text
              as="h1"
              className="text-40 sm:text-[50px] leading-[55px] sm:leading-[60px] text-midBlue font-secondary font-bold mb-5 lg:pt-7"
            >
              {title}
            </Text>
            <Text className="text-lg leading-[30px] text-midBlue font-opensans mb-7" as="div">
              {description}
            </Text>
            <div className="flex pb-10 text-white mb-6">
              <Button
                title={variant == 1 ? "ORDER NOW" : buttonDetails.text}
                href={buttonDetails.link}
                className="w-44 h-12 bg-orange text-white text-base font-opensans font-medium uppercase flex items-center justify-center rounded-full hover:bg-newOrange-100 transition-colors px-5"
              />
            </div>
            <Text as="p" className="hidden lg:block text-base text-midBlue lg:text-white font-opensans font-semibold mb-6">
              Trusted by Satisfied Clients Worldwide
            </Text>
            <div className="hidden lg:flex gap-6 flex-wrap items-end mb-5 lg:mb-0">
              <img src={amazonSvg} alt="amazon" />
              <img src={googleSvg} alt="google" />
              <img src={microsoftSvg} alt="microsoft" />
              <img src={wixSvg} alt="wix" />
              <img src={bloombergSvg} alt="bloomberg" />
            </div>
          </div>
          {enquiry_form && (
            <EnquiryForm
              title={enquiry_form?.title}
              highlightWords={enquiry_form?.highlightWords}
              highlightedColor={enquiry_form?.highlightedColor}
              subtitle={enquiry_form?.subtitle}
            />
          )}
          <Text as="p" className="lg:hidden text-base text-midBlue lg:text-white font-opensans font-semibold my-6">
            Trusted by Satisfied Clients Worldwide
          </Text>
          <div className="flex gap-10 md:gap-6 flex-wrap items-end mb-5 lg:hidden">
            <img src="https://tomedes.gumlet.io/assets/clients/amazon.svg" alt="amazon" />
            <img src="https://tomedes.gumlet.io/assets/clients/google.svg" alt="google" />
            <img src="https://tomedes.gumlet.io/assets/clients/microsoft.svg" alt="microsoft" />
            <img src="https://tomedes.gumlet.io/assets/clients/wix.svg" alt="wix" />
            <img src="https://tomedes.gumlet.io/assets/clients/bloomberg.svg" alt="bloomberg" />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row sm:justify-between xl:justify-evenly pt-5 lg:pt-16 gap-x-10 gap-y-8 lg:gap-y-0 mt-7 pb-[40px] max-w-5xl mx-auto px-5 xl:px-0">
          {!!seal.length &&
            seal.map((item, i) => (
              <div key={i} className="flex gap-3 flex-row items-center">
                {iconResolver(item.icon)}
                <Text className="text-24 text-midBlue lg:text-white font-secondary font-semibold">{item.text}</Text>
              </div>
            ))}
        </div>
      </BoxContainer>
    </div>
  );
};

export default HeroBanner;
